import { useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { NavLink } from './NavLink';

export function MobileNav() {
  const { nav } = conventionContent;
  const [open, setOpen] = useState(false);
  const drawerId = 'mobile-nav-drawer';

  return (
    <>
      <IconButton
        aria-label={nav.openMenuLabel}
        aria-expanded={open}
        aria-controls={drawerId}
        onClick={() => setOpen(true)}
        sx={{
          width: pxToRem(40),
          height: pxToRem(40),
          padding: pxToRem(8),
          marginLeft: pxToRem(7),
          marginBlock: pxToRem(11),
          color: 'common.white',
          '&:hover': { backgroundColor: 'transparent' },
        }}
      >
        <Box
          component="img"
          src={nav.menuIconSrc}
          alt=""
          aria-hidden="true"
          sx={{ width: pxToRem(24), height: pxToRem(24), display: 'block' }}
        />
      </IconButton>
      <Drawer
        id={drawerId}
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        slotProps={{
          paper: {
            'aria-label': nav.drawerLabel,
            sx: {
              backgroundColor: 'primary.main',
              color: 'common.white',
              minWidth: pxToRem(220),
              paddingInline: pxToRem(16),
              paddingBlock: pxToRem(16),
            },
          },
        }}
      >
        <Stack direction="row" sx={{ justifyContent: 'flex-start' }}>
          <IconButton
            aria-label={nav.closeMenuLabel}
            onClick={() => setOpen(false)}
            sx={{
              width: pxToRem(24),
              height: pxToRem(24),
              padding: 0,
              color: 'common.white',
              '&:hover': { backgroundColor: 'transparent' },
            }}
          >
            <Box
              component="span"
              aria-hidden="true"
              sx={{
                display: 'inline-block',
                width: pxToRem(18),
                height: pxToRem(18),
                position: 'relative',
                '&::before, &::after': {
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  margin: 'auto',
                  width: pxToRem(18),
                  height: '2px',
                  backgroundColor: 'currentColor',
                },
                '&::before': { transform: 'rotate(45deg)' },
                '&::after': { transform: 'rotate(-45deg)' },
              }}
            />
          </IconButton>
        </Stack>
        <Stack
          component="nav"
          aria-label={nav.label}
          direction="column"
          spacing={pxToRem(8)}
          sx={{ paddingTop: pxToRem(24) }}
        >
          {nav.items.map((item, index) => (
            <NavLink
              key={`${item.targetId}-${item.label}-${index}`}
              href={`#${item.targetId}`}
              label={item.label}
              onClick={() => setOpen(false)}
            />
          ))}
        </Stack>
      </Drawer>
    </>
  );
}
